"use client";
import { useRef, useState } from "react";

export function useUIState() {
  const scrollAnimationBegin = 10;
  const [scrollPositionY, setScrollPositionY] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(0);
  const [isHeroHovered, setIsHeroHovered] = useState(false);
  const hoverLeaveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isMailingListVisible, setIsMailingListVisible] = useState(false);
  const [stoneSubscribeFormStatus, setStoneSubscribeFormStatus] = useState(0);
  const [messageBox, setMessageBox] = useState("");
  const [isFloatMenuVisible, setIsFloatMenuVisible] = useState(false);
  const [shareMenuOpen, setShareMenuOpen] = useState(false);

  const navbarFixed = scrollPositionY > scrollAnimationBegin;

  return {
    scrollAnimationBegin,
    scrollPositionY,
    setScrollPositionY,
    viewportHeight,
    setViewportHeight,
    isHeroHovered,
    setIsHeroHovered,
    hoverLeaveTimerRef,
    navbarFixed,
    isMailingListVisible,
    setIsMailingListVisible,
    stoneSubscribeFormStatus,
    setStoneSubscribeFormStatus,
    messageBox,
    setMessageBox,
    isFloatMenuVisible,
    setIsFloatMenuVisible,
    shareMenuOpen,
    setShareMenuOpen,
  };
}
